<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('business.label.dictionaryInfo')" type="confirm" width="40%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="dictionary" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.no')" prop="no">
            <vxe-input v-model="dictionary.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.name')" prop="name">
            <vxe-input v-model="dictionary.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.ordinal')" prop="ordinal">
            <vxe-number-input v-model="dictionary.ordinal" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parameterValue')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <vxe-input v-model="dictionary.value" :autosize="{ minRows: 2 }" style="width: 100%" type="textarea"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.enterprise')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <vxe-select v-model="enterpriseIds" :options="enterprises" multiple style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.warehouse')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <vxe-select v-model="warehouseIds" :options="warehouses" multiple style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findAll, save } from '@/api/Api'
import { Field } from '@/api/dto/admin/Field'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { getOptions } from '@/utils/util'

export default {
  name: 'DictionaryEditor',
  data() {
    return {
      visible: false,
      loading: false,
      field: new Field(),
      dictionary: new Dictionary(),
      enterpriseIds: [],
      warehouseIds: [],
      enterprises: [],
      warehouses: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        ordinal: [{ required: true, type: 'number', min: 0, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    findAll('enterpriseFactory', { available: true }).then(res => {
      if (res.success) {
        this.enterprises = getOptions(res.result)
      }
      return findAll('warehouseFactory', { all: true })
    }).then(res => {
      if (res.success) {
        this.warehouses = getOptions(res.result)
      }
    })
  },
  methods: {
    add(field) {
      this.visible = true
      this.field = field
      this.dictionary = new Dictionary()
      this.dictionary.available = true
      this.enterpriseIds = []
      this.warehouseIds = []
    },
    edit(field, row, copy) {
      this.visible = true
      this.field = field
      if (copy) {
        row.id = undefined
        row.version = undefined
      }
      this.dictionary = new Dictionary(row)
      this.enterpriseIds = row.enterprises.map(item => item.id)
      this.warehouseIds = row.warehouses.map(item => item.id)
    },
    save() {
      this.loading = true
      const field = this.field.toJSONObject()
      const dictionary = this.dictionary.toJSONObject()
      dictionary.enterprises = this.enterpriseIds.map(item => {
        return { id: item }
      })
      dictionary.warehouses = this.warehouseIds.map(item => {
        return { id: item }
      })
      field.dictionaries = [dictionary]
      save('fieldPersister', field).then(res => {
        if (res.success) {
          this.$emit('success')
          this.$message.success(this.$t('message.saveSuccess'))
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>